export default __webpack_public_path__ + "static/media/CRM_Final.4bab07bc.png";